<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="配置职位"
      destroy-on-close
      :visible.sync="show"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" :model="form" label-width="160px" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="项目人员动态职位" prop="value1">
                <el-select v-model="form.value1" multiple placeholder="请选择" style="width: 500px" @change="changePost">
                  <el-option v-for="item in dimensionOptions" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },

  data() {
    return {
      show: false,
      dimensionOptions: [],
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      value1: '',
      form: { value1: [] },
      rules: {
        value1: [
          {
            required: true,
            message: '请选择项目人员动态职位',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      that.dimensionOptions = utils.findDictList('zw', that.allDataDict)
    })
  },
  methods: {
    //数据字典转换
    changePost(value) {
      if (value.length) {
        let nameList = []
        value.forEach((e) => {
          const index = this.dimensionOptions.find((v) => v.key == e)
          if (index) {
            nameList.push(index.name)
          }
          this.form.valid_names = nameList.join(',')
          this.form.valid_type = value.join(',')
        })
      }
    },
    // 根据租户获取配置
    getDetail(refId) {
      this.form = { refId: refId, value1: [] }
      let that = this
      that.dialogShow = true
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=construction_personnel').then((resp) => {
        if (resp && resp.data) {
          if (resp.data.sub_data_switch_config_detail.length) this.form = Object.assign(this.form, resp.data.sub_data_switch_config_detail[0])
          this.form.value1 = this.form.valid_type ? this.form.valid_type.split(',') : []
          this.$refs.form && this.$refs.form.resetFields()
          this.show = true
        }
      })
    },
    //关闭表单
    handleClose() {
      this.show = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      this.loading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .put('${portal}/portal/data_switch_config_detail/updateList', [this.form])
            .then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped></style>
